import { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import BakeasyConfirmDialog, {
	BakeasyConfirmDialogProp,
} from "./components/dialogs/BakeasyConfirmDialog";
import { BakeasyLoaderProp } from "./components/loaders/BakeasyLoader";
import { AppContext } from "./context/AppContext";
import AppRoutes from "./routes/AppRoutes";
import BakeasyDialog, {
	BakeasyDialogProp,
} from "./components/dialogs/BakeasyDialog";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Provider } from "react-redux";
import BakeasyLoaderRedux from "./components/loaders/BakeasyLoaderRedux";
import BakeasySnackbarRedux from "./components/snackbars/BakeasySnackBarRedux";
import { store } from "./redux_store/reduxStore";
import { BakeasySnackbarProp } from "./components/snackbars/BakeasySnackBar";

const App = () => {
	const [snackbar, setSnackbar] = useState<BakeasySnackbarProp>({});
	const [loader, setLoader] = useState<BakeasyLoaderProp>({});

	const [dialog, setDialog] = useState<BakeasyDialogProp>({});
	const [confirmDialog, setConfirmDialog] = useState<BakeasyConfirmDialogProp>(
		{}
	);

	return (
		<Provider store={store}>
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<AppContext.Provider
					value={{
						loader,
						setLoader,
						dialog,
						setDialog,
						snackbar,
						setSnackbar,
						confirmDialog,
						setConfirmDialog,
						// isMobileView,
						// setIsMobileView,
					}}
				>
					<BrowserRouter>
						<AppRoutes />
						<BakeasyDialog dialog={dialog} />
						<BakeasyLoaderRedux />
						<BakeasySnackbarRedux />
						<BakeasyConfirmDialog dialog={confirmDialog} />
					</BrowserRouter>
				</AppContext.Provider>
			</LocalizationProvider>
		</Provider>
	);
};

export default App;
